import React, { useEffect, useRef, useState } from "react";
import { SearchPanel } from "./SearchPanel";
import { notify } from "./Toast/Toast";

export function AddView(props) {
  const type = props.type;
  const [itemGroups, setItemGroups] = useState([]);
  const [subItemGroups, setSubItemGroups] = useState([]);
  const [selectedItemGroup, setSelectedItemGroup] = useState("");
  const getInitialState = () => {
    let baseState = {
      type: type, // Using the 'type' prop passed to the component
    };

    switch (type) {
      case "Product":
        return {
          ...baseState, // Spread the baseState to include 'type'
          Name: "",
          Price: "",
          Volume: "",
          ItemGroupID: "",
          ItemSubGroupID: "",
          EAN1: "",
        };
      case "InventoryData":
        return {
          ...baseState, // Spread the baseState to include 'type'
          ID: props.id,
          barID: 0,
          items: [],
        };
      case "Inventory":
        const today = new Date();
        const date = today.toISOString().split("T")[0];
        const name = [
          "Januari",
          "Februari",
          "Mars",
          "April",
          "Maj",
          "Juni",
          "Juli",
          "Augusti",
          "September",
          "Oktober",
          "November",
          "December",
        ][today.getMonth()];

        return {
          Name: name,
          StartDate: date,
        };
      case "Bar":
        return {
          ...baseState,
          Name: "",
        };
      default:
        return baseState; // Return baseState for the default case
    }
  };

  const [formData, setFormData] = useState(getInitialState());

  useEffect(() => {
    console.log(formData);
  }, [formData]);

  useEffect(() => {
    // Fetch item groups
    fetch(
      "https://inventy.redata.se/inventdb/api-itemGroups.php?Command=Select",
    )
      .then((response) => response.json())
      .then((data) => setItemGroups(data))
      .catch((error) => {
        notify("error", "Kunde inte hämta produktgrupper")
        console.log(error)});
  }, []);

  useEffect(() => {
    // Fetch sub item groups
    fetch(
      "https://inventy.redata.se/inventdb/api-itemSubGroup.php?Command=Select",
    )
      .then((response) => response.json())
      .then((data) => setSubItemGroups(data))
      .catch((error) => {
        notify("error", "Kunde inte hämta subgrupper")
        console.log(error)})
  }, []);

  const handleInputChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  const handleItemGroupChange = (event) => {
    setSelectedItemGroup(event.target.value);
    setFormData({
      ...formData,
      ItemGroupID: event.target.value,
    });
  };

  const handleSubItemGroupChange = (event) => {
    setFormData({
      ...formData,
      ItemSubGroupID: event.target.value,
    });
  };

  function Abort() {
    props.setAddView(false);
  }

  function Post() {
    switch (type) {
      case "Product": {
        fetch("https://inventy.redata.se/inventdb/api_addProducts.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((data) => {
            notify("success", "Produkt tillagd")
            Abort();
            props.refresh();
          })
          .catch((error) => {
            notify("error", "Kunde inte lägga till produkt")
            console.log(error)});
        break;
      }
      case "InventoryData": {
        fetch("https://inventy.redata.se/inventdb/api_addInventoryData.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((data) => {
            notify("success", "Produkt tillagd")
            Abort();
            props.refresh();
          })
          .catch((error) => {
            notify("error", "Kunde inte lägga till produkt")
            console.log(error)});

        break;
      }
      case "Inventory": {
        fetch("https://inventy.redata.se/inventdb/api_addInventoryCount.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((data) => {
            notify("success", "Inventering skapad")
            props.refresh();
            props.setSelected(data.id);
            Abort();
          })
          .catch((error) => {
            notify("error", "Kunde inte skapa inventering")
            console.error("Error:", error);
          });
        break;
      }
      case "Bar": {
        fetch("https://inventy.redata.se/inventdb/api_addBar.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((data) => {
            notify("success", "Bar skapad")
            props.refresh();
            Abort();
          })
          .catch((error) => {
            notify("error", "Kunde inte lägga till bar")
            console.error("Error:", error);
          });
        break;
      }
    }
  }

  function AddInventoryData() {
    const [search, setSearch] = useState("");
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [bars, setBars] = useState([]);
    const inputRef = useRef(null);
    const searchRef = useRef(1);

    // Fetch all products when the component mounts
    useEffect(() => {
      fetch("https://inventy.redata.se/inventdb/api_bars.php?Command=Select")
        .then((response) => response.json())
        .then((data) => {
          if (Array.isArray(data)) {
            setBars(data);
          } else {
            console.error("Fetched data is not an array:", data);
          }
        })
        .catch((error) => {
          notify("error", "Kunde inte hämta barer")
          console.error("Error fetching data: ", error);
        });
    }, []);

    useEffect(() => {
      fetch(
        "https://inventy.redata.se/inventdb/api_products.php?Command=Select",
      )
        .then((response) => response.json())
        .then((data) => {
          if (Array.isArray(data)) {
            setProducts(data);
            setFilteredProducts(data); // Initially, filteredProducts is the same as products
          } else {
            console.error("Fetched data is not an array:", data);
          }
        })
        .catch((error) => {
          notify("error", "Kunde inte hämta produkter")
          console.error("Error fetching data: ", error);
        });
    }, []);

    function handleItemSelection(selectedProduct) {
      if (selectedItems.includes(selectedProduct)) {
      } else {
        // If not selected, add it to the list
        setSelectedItems([...selectedItems, selectedProduct]);
        setFormData({
          ...formData,
          items: [...formData.items, { ID: selectedProduct.ID, Amount: 1 }],
        });
      }
    }
    useEffect(() => {
      if (selectedItems.length !== 0) {
        inputRef.current.focus();
      }
    }, [selectedItems]);

    useEffect(() => {
      if (search.length > 2) {
        const filtered = products.filter((product) => {
          // Check if search matches exactly with Name, EAN1, EAN2, or EAN3
          const isExactMatch =
            product.Name.toLowerCase() === search.toLowerCase() ||
            product.EAN1 === search ||
            product.EAN2 === search ||
            product.EAN3 === search;

          // If there's an exact match, call handleItemSelection
          if (isExactMatch) {
            handleItemSelection(product);
          }

          // Continue with filtering based on the original criteria
          return (
            (product.Name.toLowerCase().includes(search.toLowerCase()) ||
              product.ItemGroup.toLowerCase().includes(search.toLowerCase()) ||
              product.ItemSubGroup.toLowerCase().includes(
                search.toLowerCase(),
              )) &&
            !selectedItems.some((object) => object.ID === product.ID)
          );
        });

        setFilteredProducts(filtered);
      } else {
        setFilteredProducts([]); // Set to empty array if search length is less than 3
      }
    }, [search, products, selectedItems]); // Make sure to include relevant dependencies

    function handleRemove(ID) {
      setSelectedItems(selectedItems.filter((item) => item.ID !== ID));
    }

    useEffect(() => {}, [formData]);

    function handleAmountChange(productID, newAmount) {
      const updatedItems = formData.items.map((item) => {
        if (item.ID === productID) {
          return { ...item, Amount: newAmount };
        }
        return item;
      });

      setFormData({ ...formData, items: updatedItems });
    }

    const handleBarSelection = (event) => {
      setFormData({
        ...formData,
        barID: event.target.value,
      });
    };

    if (formData.barID === 0) {
      return (
        <div>
          <select name="barID" id="bar" onChange={handleBarSelection}>
            <option>Välj bar:</option>
            {bars.map((item) => (
              <option key={item.ID} value={item.ID}>
                {item.name}
              </option>
            ))}
          </select>
        </div>
      );
    } else {
      return (
        <div className="Widget" onClick={() => setSearch("")}>
          <h1>Lägg till Artikel</h1>
          <form
            className="FlexContainer"
            style={{
              padding: "3vh",
              flexDirection: "column",
              alignContent: "center",
            }}
          >
            <div style={{ position: "relative", width: "100%", margin: 0 }}>
              <SearchPanel
                type="live"
                setSearch={setSearch}
                live={true}
                searchRef={searchRef}
                pickEnter={() => handleItemSelection(filteredProducts[0])}
              />
              <div
                style={{
                  position: "absolute",
                  top: "41pz", // Position it right below the SearchPanel
                  left: 0,
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  backgroundColor: "rgba(255, 255, 255, 0.9)",
                  maxHeight: "80vh",
                  overflowY: "auto",
                  zIndex: 1000, // Ensures the div is on top
                }}
              >
                {filteredProducts.slice(0, 5).map((product) => (
                  <div
                    className="hoverButton"
                    style={{ padding: "3vh" }}
                    key={product.ID}
                    onClick={() => handleItemSelection(product)}
                  >
                    <p>{product.Name}</p>
                  </div>
                ))}
              </div>
            </div>

            <table style={{ textAlign: "center" }}>
              <thead>
                <tr>
                  <th width="10%" style={{ backgroundColor: "var(--block)" }}>
                    {""}
                  </th>
                  <th width="45%" style={{ backgroundColor: "var(--block)" }}>
                    Produkt
                  </th>
                  <th width="45%" style={{ backgroundColor: "var(--block)" }}>
                    Antal
                  </th>
                </tr>
              </thead>
              <tbody>
                {selectedItems.map((selected) => (
                  <tr key={selected.ID}>
                    <td>
                      <div
                        className="Delete"
                        style={{ borderRadius: "5vh", padding: "1vh" }}
                        onClick={() => handleRemove(selected.ID)}
                      >
                        x
                      </div>
                    </td>
                    <td>{selected.Name + " " + selected.ItemSubGroup}</td>
                    <td>
                      <input
                        ref={inputRef}
                        type="number"
                        style={{ width: "60px" }}
                        onKeyPress={(event) => {
                          if (event.key === "Enter") {
                            event.preventDefault();
                            searchRef.current.focus();
                          }
                        }}
                        onChange={(e) =>
                          handleAmountChange(selected.ID, e.target.value)
                        }
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </form>
        </div>
      );
    }
  }

  function addProdukt() {
    return (
      <>
        <h1>Ny Produkt</h1>
        <form className="FlexContainer">
          <div>
            <label>
              <h3>Namn</h3>
            </label>
            <input type="Text" name="Name" onChange={handleInputChange} />
          </div>
          <div>
            <label>
              <h3>Pris</h3>
            </label>
            <input
              type="number"
              name="Price"
              className="numberInput"
              onChange={handleInputChange}
            />
            <label> kr</label>
          </div>
          <div>
            <label>
              <h3>Volym</h3>
            </label>
            <input
              type="number"
              name="Volume"
              className="numberInput"
              onChange={handleInputChange}
            />
            <label> L</label>
          </div>
          <div>
            <label>
              <h3>EAN</h3>
            </label>
            <input
              type="text"
              name="EAN1"
              className="numberInput"
              onChange={handleInputChange}
            />
          </div>

          <div>
            <label htmlFor="ItemGroup">
              <h3>Artikelgrupp</h3>
            </label>
            <select
              name="ItemGroupID"
              id="ItemGroup"
              onChange={handleItemGroupChange}
            >
              <option value="">Välj en artikelgrupp</option>
              {itemGroups.map((item) => (
                <option key={item.ID} value={item.ID}>
                  {item.Name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label htmlFor="ItemSubGroup">
              <h3>Undergrupp</h3>
            </label>
            <select
              name="ItemSubGroupID"
              id="ItemSubGroup"
              onChange={handleSubItemGroupChange}
            >
              <option value="">Välj en undergrupp</option>
              {subItemGroups
                .filter((subItem) => subItem.ItemGroupID === selectedItemGroup)
                .map((subItem) => (
                  <option key={subItem.ID} value={subItem.ID}>
                    {subItem.Name}
                  </option>
                ))}
            </select>
          </div>
        </form>
      </>
    );
  }

  function AddInventory() {
    return (
      <>
        <h1>Ny Inventering</h1>
        <form style={{ padding: "3vh" }}>
          <label>
            <h3>Namn</h3>
          </label>
          <input
            name="Name"
            value={formData.Name}
            onChange={handleInputChange}
          />
          <label>
            <h3>Startdatum</h3>
          </label>
          <input
            type="date"
            name="StartDate"
            value={formData.StartDate}
            onChange={handleInputChange}
          />
        </form>
      </>
    );
  }

  function AddBar() {
    return (
      <>
        <h1>Ny Bar</h1>
        <form style={{ padding: "3vh" }}>
          <label>
            <h3>Namn</h3>
          </label>
          <input
            name="Name"
            value={formData.Name}
            onChange={handleInputChange}
          />
        </form>
      </>
    );
  }

  function getForm() {
    switch (type) {
      case "Product":
        return addProdukt();

      case "InventoryData":
        return AddInventoryData();

      case "Inventory":
        return AddInventory();

      case "Bar":
        return AddBar();
    }
  }

  return (
    <div
      className="NavMenuContainer"
      style={{
        justifyContent: "center",
        textAlign: "center",
        alignItems: "center",
      }}
    >
      <div className="addView">
        {props.name != null && <h2>{props.name}</h2>}
        {getForm()}

        <div className="FlexContainer">
          <button onClick={Abort}>Avbryt</button>
          <button onClick={Post}>Lägg till</button>
        </div>
      </div>
    </div>
  );
}
